import React, { createContext, Dispatch, FC, SetStateAction, useState } from 'react'
import { IModalContent } from '../../../context/interface'
import { TCustomerDetailTab } from 'apps/Panel/views/CustomerDetail/interface'

export interface UIContextValues {
  buttonRedirectToAdminVisible: boolean
  isNavigationForHome: boolean
  changeIsBreadcrumbHidden: (value: boolean) => void
  changeCustomerDetailsSelectedTab: (tab: TCustomerDetailTab) => void
  isNavigationHidden: boolean
  isVisibleMobile: boolean
  setIsVisibleMobile: Dispatch<SetStateAction<boolean>>
  customerDetailsSelectedTab: 'cards' | 'charges' | 'shippings'
  changeCenterFlexboxChildColumInMainContent: (value: boolean) => void
  changeNavigationVisible: (value: boolean) => void
  isBreadcrumbHidden: boolean
  changeIsNavigationHidden: (value: boolean) => void
  navigationExpanded: boolean
  centerFlexboxChildColumInMainContent: boolean
  changeButtonRedirectToAdminVisible: (value: boolean) => void
  changeNavigationForHome: (value: boolean) => void
  createModal(children: React.ReactChild, data: unknown): void
  removeModal(): void
  modalContent: IModalContent | undefined
  updateModal(data: unknown): void
}

export const UIContext = createContext<UIContextValues>({} as any)
const useUIContext = (): UIContextValues => {
  // UI ················································································································
  const [buttonRedirectToAdminVisible, setButtonRedirectToAdminVisible] = useState(false)
  const [centerFlexboxChildColumInMainContent, setCenterFlexboxChildColumInMainContent] = useState(false)
  const [customerDetailsSelectedTab, setCustomerDetailsSelectedTab] = useState<TCustomerDetailTab>('charges')
  const [isBreadcrumbHidden, setBreadcrumbHidden] = useState<boolean>(false)
  const [isNavigationForHome, setNavigationForHome] = useState<boolean>(false)
  const [isNavigationHidden, setIsNavigationHidden] = useState<boolean>(false)
  const [isVisibleMobile, setIsVisibleMobile] = useState<boolean>(false)
  const [navigationExpanded, setNavigationExpanded] = useState<boolean>(false)
  const changeButtonRedirectToAdminVisible = (value: boolean) => setButtonRedirectToAdminVisible(value)
  const changeCenterFlexboxChildColumInMainContent = (value: boolean) => setCenterFlexboxChildColumInMainContent(value)
  const changeCustomerDetailsSelectedTab = (tab: TCustomerDetailTab) => setCustomerDetailsSelectedTab(tab)
  const changeIsBreadcrumbHidden = (value: boolean) => setBreadcrumbHidden(value)
  const changeIsNavigationHidden = (value: boolean) => setIsNavigationHidden(value)
  const changeNavigationForHome = (value: boolean) => setNavigationForHome(value)

  // MODAL ·············································································································
  const MODAL_INITIAL_STATE = undefined
  const [modalContent, setModalContent] = useState<IModalContent | undefined>(MODAL_INITIAL_STATE)
  const createModal = (children: React.ReactChild, data: any) => setModalContent({ children, data })
  const removeModal = () => setModalContent(MODAL_INITIAL_STATE)
  const updateModal = (data: any): void =>
    setModalContent({ children: modalContent?.children, data: { ...modalContent?.data, ...data } })

  return {
    buttonRedirectToAdminVisible,
    centerFlexboxChildColumInMainContent,
    changeButtonRedirectToAdminVisible,
    changeCenterFlexboxChildColumInMainContent,
    changeCustomerDetailsSelectedTab,
    changeIsBreadcrumbHidden,
    changeIsNavigationHidden,
    changeNavigationForHome,
    changeNavigationVisible: setNavigationExpanded,
    customerDetailsSelectedTab,
    isBreadcrumbHidden,
    isNavigationForHome,
    isNavigationHidden,
    isVisibleMobile,
    setIsVisibleMobile,
    navigationExpanded,
    createModal,
    modalContent,
    removeModal,
    updateModal
  }
}

export const UIContextProvider: FC = ({ children }: any) => {
  const state = useUIContext()

  return <UIContext.Provider value={state}>{children}</UIContext.Provider>
}
